import Scenario from "./scenarioElements/Scenario";
import Input from "./Input";
import TextVariables from "./TextVariables";
import Engine from "./Engine";
import Store from "../state/store";
import { CustomEventTypes } from "../globals";
import { KeyCodes } from "../interfaces/Input";
import { IConditionItem } from "../interfaces/Trigger";

export default class StepConditionsManager
{
	static currentStepConditions = new Array<IConditionItem>();
	static initialMonitoredVariables = new Array<string>();
	static changedMonitoredVariablesIndexes = new Array<number>();

	static init()
	{
		document.addEventListener(CustomEventTypes.simulationStarted, StepConditionsManager.setStepConditions);
		document.addEventListener(CustomEventTypes.simulationStopped, StepConditionsManager.clearStepConditions);
	}

	static setStepConditions()
	{
		StepConditionsManager.currentStepConditions = Store.getState().scenarioModule.stepConditions[Scenario.currentStep()?.id || ""] ?? [];
		StepConditionsManager.initialMonitoredVariables = [];
		StepConditionsManager.changedMonitoredVariablesIndexes = [];
		
		for(let i = 0; i < StepConditionsManager.currentStepConditions.length; i++)
		{
			const monitoredVariable = TextVariables.textToData(StepConditionsManager.currentStepConditions[i].monitoredVariable);
			StepConditionsManager.initialMonitoredVariables.push(monitoredVariable);
		}
	}

	//called every frame while simulation is running
	static update()
	{
		if(Input.getKeyDown(KeyCodes.C))
		{
			for(let i = 0; i < StepConditionsManager.currentStepConditions.length; i++)
			{
				if(StepConditionsManager.currentStepConditions[i].monitoredVariable === "debug" && !StepConditionsManager.changedMonitoredVariablesIndexes.includes(i))
				{
					StepConditionsManager.changedMonitoredVariablesIndexes.push(i);
				}
			}
		}
		
		for(let i = 0; i < StepConditionsManager.currentStepConditions.length; i++)
		{
			if(StepConditionsManager.changedMonitoredVariablesIndexes.includes(i)) continue;

			if(TextVariables.textToData(StepConditionsManager.currentStepConditions[i].monitoredVariable) !== StepConditionsManager.initialMonitoredVariables[i])
			{
				StepConditionsManager.changedMonitoredVariablesIndexes.push(i);
				StepConditionsManager.initialMonitoredVariables[i] = TextVariables.textToData(StepConditionsManager.currentStepConditions[i].monitoredVariable);
			}
		}

		for(const changedMonitoredVariableIndex of StepConditionsManager.changedMonitoredVariablesIndexes)
		{
			const evaluationResult = StepConditionsManager.evaluateExpression(StepConditionsManager.currentStepConditions[changedMonitoredVariableIndex].conditionExpression);
			if(evaluationResult === "true")
			{
				for(const trigger of StepConditionsManager.currentStepConditions[changedMonitoredVariableIndex].triggers)
				{
					Engine.getInstance().getTriggerManager().runTrigger(trigger);
				}

				if(StepConditionsManager.initialMonitoredVariables.length === 0 || StepConditionsManager.changedMonitoredVariablesIndexes.length === 0)
				{
					break;
				}

				StepConditionsManager.initialMonitoredVariables[changedMonitoredVariableIndex] = TextVariables.textToData(StepConditionsManager.currentStepConditions[changedMonitoredVariableIndex].monitoredVariable);
				StepConditionsManager.changedMonitoredVariablesIndexes.splice(StepConditionsManager.changedMonitoredVariablesIndexes.indexOf(changedMonitoredVariableIndex), 1);
			}
			else if ( evaluationResult === "false") //added to prevent spamming of monitored variable, if the expression was false stop listening to the variable until it's changed again
			{
				StepConditionsManager.initialMonitoredVariables[changedMonitoredVariableIndex] = TextVariables.textToData(StepConditionsManager.currentStepConditions[changedMonitoredVariableIndex].monitoredVariable);
				StepConditionsManager.changedMonitoredVariablesIndexes.splice(StepConditionsManager.changedMonitoredVariablesIndexes.indexOf(changedMonitoredVariableIndex), 1);
			}
		}
	}

	//called when simulation has stopped
	static clearStepConditions()
	{
		StepConditionsManager.currentStepConditions = [];
		StepConditionsManager.initialMonitoredVariables = [];
		StepConditionsManager.changedMonitoredVariablesIndexes = [];
	}

	static evaluateExpression(expression: string)
	{
		return TextVariables.evaluateExpression(expression).toString();
	}
}
